import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaicab() {



const cardData = {
  keyword: " Pune to Mumbai Cab",

headingDescription:
  "Velocity Cab offers reliable and comfortable Pune to Mumbai cab services designed to make your intercity travel smooth, safe, and convenient. Whether you are traveling for business meetings, airport transfers, family trips, or weekend getaways, our professional drivers and well-maintained vehicles ensure a hassle-free journey from Pune to Mumbai. We provide flexible booking options including one-way trips, round trips, and customized travel packages with transparent pricing and no hidden charges. Our diverse fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for individuals, families, and corporate groups. With easy online booking, punctual pickups anywhere in Pune, and 24/7 customer support, Velocity Cab stands out as a trusted choice for Pune to Mumbai cab travel.",

topPlaces: [
  {
    title: "Elephanta Caves",
    description: "Elephanta Caves is a UNESCO World Heritage Site located on Elephanta Island and is one of Mumbai's most remarkable historical attractions. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable drive to the Gateway of India before taking a ferry to explore the ancient rock-cut caves. The impressive sculptures, especially the massive Trimurti of Lord Shiva, make it a must-visit destination for history lovers and photographers."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a peaceful destination surrounded by lush greenery, luxury hotels, cafés, and scenic walking paths. Visitors choosing an Innova Crysta on rent in Pune can comfortably reach this beautiful location to enjoy boating, lakeside dining, and relaxing evening strolls. It is an ideal spot for families, couples, and anyone looking to unwind in the heart of Mumbai."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Terminus",
    description: "Chhatrapati Shivaji Maharaj Terminus is a UNESCO World Heritage Site renowned for its stunning Victorian Gothic architecture. Travelers renting an Innova Crysta in Pune can conveniently visit this iconic railway station while exploring nearby heritage buildings, local markets, and historic streets that showcase Mumbai's rich colonial legacy."
  },
  {
    title: "Bandra Fort",
    description: "Bandra Fort, also known as Castella de Aguada, is a historic Portuguese fort overlooking the Arabian Sea. Travelers hiring an Innova Crysta on rent in Pune can enjoy breathtaking views of the Bandra-Worli Sea Link, explore the ancient fort walls, and capture memorable photographs from one of Mumbai's most scenic viewpoints."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is one of Mumbai's most famous beaches, attracting visitors with its lively atmosphere, delicious street food, and spectacular sunsets. Booking an Innova Crysta on rent in Pune makes the road journey comfortable for families and groups planning a fun-filled beach outing and a relaxing evening by the Arabian Sea."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is an architectural masterpiece and an internationally renowned meditation center near Gorai. Visitors choosing an Innova Crysta on rent in Pune can comfortably explore its magnificent golden dome, peaceful meditation halls, and informative museum while enjoying a calm and spiritual experience."
  },
  {
    title: "Hanging Gardens",
    description: "Hanging Gardens on Malabar Hill offer beautifully landscaped gardens, artistic hedges, and panoramic views of Marine Drive. Travelers renting an Innova Crysta in Pune can spend a peaceful afternoon surrounded by greenery while enjoying one of Mumbai's most popular viewpoints overlooking the Arabian Sea."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's busiest shopping streets, offering trendy fashion, antiques, handicrafts, cafés, and local restaurants. Travelers booking an Innova Crysta on rent in Pune can comfortably explore this lively market and enjoy a memorable shopping experience in the heart of South Mumbai."
  },
  {
    title: "Siddhivinayak Temple",
    description: "Siddhivinayak Temple is one of Mumbai's most sacred temples dedicated to Lord Ganesha. Visitors hiring an Innova Crysta on rent in Pune can conveniently visit this famous spiritual destination to seek blessings while experiencing the temple's peaceful atmosphere and remarkable architecture."
  },
  {
    title: "Worli Sea Face",
    description: "Worli Sea Face is a scenic coastal promenade known for its cool sea breeze, beautiful skyline, and stunning sunset views. Travelers choosing an Innova Crysta on rent in Pune can relax by the waterfront, enjoy leisurely walks, and admire spectacular views of the Arabian Sea and the Bandra-Worli Sea Link."
  }
],



services: [
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service provides reliable and comfortable transportation between the two major cities of Maharashtra. Professional drivers ensure safe highway travel with punctual pickup services from homes, offices, hotels, railway stations, and airport terminals. Vehicles are well maintained and suitable for business travel, tourism trips, and family journeys. Air-conditioned cars ensure relaxed travel during the 3–4 hour journey. Ideal for one way travel or round trips. Flexible booking options allow passengers to reserve cabs anytime."
},
{
name: "Mumbai to Pune Taxi",
description: "Mumbai to Pune taxi service offers convenient travel solutions for passengers traveling between the commercial capital and Pune city. Comfortable vehicles with professional drivers provide safe and punctual transportation across the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travelers, tourists, and families. Spacious vehicles ensure comfortable long-distance journeys. Flexible booking options make taxi reservations quick and easy."
},
{
name: "Pune to Mumbai Cheapest Cab",
description: "Pune to Mumbai cheapest cab service offers affordable transportation without compromising comfort and safety. Travelers can book budget-friendly cars for quick and convenient highway journeys between Pune and Mumbai. Professional drivers ensure safe driving and timely pickup services. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for students, tourists, and daily commuters. Air-conditioned vehicles ensure pleasant travel. Flexible booking options allow cost-effective ride reservations."
},
{
name: "Pune to Mumbai Cab Service",
description: "Pune to Mumbai cab service provides dependable transportation for passengers traveling across Maharashtra’s busiest route. Vehicles are well maintained and suitable for comfortable expressway journeys. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business trips, airport transfers, and weekend travel. Spacious vehicles ensure relaxed journeys. Flexible booking options allow easy cab reservations."
},
{
name: "Pune to Mumbai Cab Fare",
description: "Pune to Mumbai cab fare services provide transparent pricing and convenient travel options for passengers planning city-to-city journeys. Travelers receive clear information about cab fares, toll charges, and driver allowances before booking. Vehicles are comfortable and suitable for highway travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel and tourism trips. Flexible booking options allow passengers to compare and reserve rides easily."
},
{
name: "Pune Mumbai Taxi Service",
description: "Pune Mumbai taxi service offers comfortable and reliable transportation between Pune and Mumbai. Professional drivers ensure safe driving and punctual pickup services for passengers traveling via the Mumbai–Pune Expressway. Vehicles are well maintained and suitable for both one way and round trip journeys. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for corporate travelers, tourists, and families. Air-conditioned vehicles ensure smooth and comfortable travel experiences."
},
{
name: "Pune to Mumbai Cab Booking",
description: "Pune to Mumbai cab booking service allows travelers to easily reserve taxis for convenient intercity travel. Online booking options help passengers confirm rides quickly with transparent pricing. Vehicles are suitable for long-distance highway travel with professional drivers ensuring safe and punctual journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, airport transfers, and tourism trips. Flexible scheduling ensures easy travel planning."
},
{
name: "Pune Mumbai Cab Rental",
description: "Pune Mumbai cab rental service offers comfortable vehicles for travelers planning city-to-city trips between Pune and Mumbai. Rental vehicles are well maintained and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family travel, corporate trips, and tourism visits. Spacious interiors ensure comfortable rides. Flexible rental packages allow convenient travel planning."
},
{
name: "Pune Mumbai Pune Car Rental",
description: "Pune Mumbai Pune car rental service provides round-trip transportation for travelers planning return journeys between the two cities. Vehicles are suitable for comfortable highway travel with experienced drivers ensuring safe driving services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business visits, meetings, and family travel. Air-conditioned vehicles ensure comfortable rides during long journeys. Flexible packages allow easy round-trip bookings."
},
{
name: "Pune Mumbai Taxi Price",
description: "Pune Mumbai taxi price services help travelers find the best transportation options between Pune and Mumbai at competitive rates. Transparent pricing ensures passengers know the cost before confirming the booking. Vehicles are comfortable and suitable for highway travel. Professional drivers provide punctual pickup and safe driving services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow passengers to choose the best ride for their budget."
},
{
name: "Pune Mumbai Car Rental",
description: "Pune Mumbai car rental service offers convenient vehicle hire options for travelers planning trips between the two cities. Vehicles are well maintained and suitable for expressway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism travel, corporate trips, and family visits. Spacious vehicles ensure relaxed journeys. Flexible booking options allow easy car reservations."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious and comfortable SUV travel for passengers traveling between Pune and Mumbai. The Ertiga vehicle provides ample seating and luggage space suitable for family trips and group travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for airport transfers, weekend trips, and corporate travel. Flexible booking options allow easy reservations."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable highway travel. Innova vehicles offer spacious seating and smooth ride quality suitable for families and business travelers. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for corporate travel, airport transfers, and tourism trips. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune to Mumbai Innova Crysta",
description: "Pune to Mumbai Innova Crysta cab service offers luxury SUV travel with premium interiors and spacious seating. The vehicle is ideal for long-distance highway journeys across the Mumbai–Pune Expressway. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate executives, families, and VIP travel. Flexible booking options allow convenient luxury ride reservations."
},
{
name: "Pune to Mumbai International Airport Cab",
description: "Pune to Mumbai international airport cab service offers reliable transportation for passengers traveling to Mumbai Airport terminals. Vehicles provide comfortable seating and sufficient luggage space suitable for airport transfers. Professional drivers monitor flight schedules to ensure timely pickup and drop services. Pickup services are available from homes, hotels, offices, and railway stations. Ideal for business travelers, tourists, and families. Flexible booking options allow advance airport ride reservations."
},
{
name: "Pune to Mumbai One Way Cab",
description: "Pune to Mumbai one way cab service provides convenient single-trip transportation for travelers who do not require return travel. Vehicles are well maintained and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business trips, airport transfers, and tourism visits. Comfortable vehicles ensure smooth travel experiences. Flexible booking options allow quick reservations."
},
{
name: "Pune to Mumbai Taxi Service",
description: "Pune to Mumbai taxi service offers dependable transportation with experienced drivers and comfortable vehicles. The service focuses on punctual pickup and safe driving along the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate travel, family trips, and tourism visits. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow convenient ride scheduling."
},
{
name: "Cab from Pune to Mumbai",
description: "Cab from Pune to Mumbai service provides comfortable intercity transportation for passengers traveling between the two cities. Vehicles are suitable for expressway travel with professional drivers ensuring safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business meetings, tourism visits, and family trips. Spacious vehicles ensure relaxed travel experiences. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai airport cab service offers reliable transportation for passengers traveling to Mumbai airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport transfers. Professional drivers ensure punctual pickup and safe driving services across the expressway. Pickup services are available from homes, hotels, offices, and railway stations. Ideal for international and domestic travelers. Flexible booking options allow advance ride reservations."
},
{
name: "Cheap Pune to Mumbai Cab",
description: "Cheap Pune to Mumbai cab service provides budget-friendly travel options for passengers looking for economical transportation. Vehicles offer comfortable seating and reliable highway travel at affordable prices. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for students, tourists, and daily travelers. Flexible booking options allow cost-effective ride reservations."
},
{
name: "Pune to Mumbai Outstation Cab",
description: "Pune to Mumbai outstation cab service offers comfortable transportation for travelers planning trips outside their city. Vehicles are suitable for long-distance highway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business trips, tourism travel, and family visits. Spacious vehicles ensure relaxed journeys. Flexible booking options allow convenient travel planning."
}
],

tableData: [
["Pune Mumbai Cab","Mumbai to Pune Taxi"],
["Pune to Mumbai Cheapest Cab","Pune to Mumbai Cab Service"],
["Pune to Mumbai Cab Fare","Pune Mumbai Taxi Service"],
["Pune to Mumbai Cab Booking","Pune Mumbai Cab Rental"],
["Pune Mumbai Pune Car Rental","Pune Mumbai Taxi Price"],
["Pune Mumbai Car Rental","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Pune to Mumbai Innova Crysta"],
["Pune to Mumbai International Airport Cab","Pune to Mumbai One Way Cab"],
["Pune to Mumbai Taxi Service","Cab from Pune to Mumbai"],
["Pune to Mumbai Airport Cab","Cheap Pune to Mumbai Cab"],
["Pune to Mumbai Outstation Cab","Pune to Mumbai Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Velocity Cabs provides skilled and experienced drivers who regularly travel on the Pune to Mumbai Expressway and old highway routes. Our drivers ensure safe driving, smooth navigation, and timely arrival for a comfortable intercity journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers clear and transparent pricing for Pune to Mumbai cab services. Customers receive complete fare details including toll charges and travel costs before confirming the booking with no hidden fees."
  },
  {
    WhyChooseheading: "24/7 Pune to Mumbai Cab Availability",
    WhyChoosedescription: "Our Pune to Mumbai cab service is available 24 hours a day. Whether you need an early morning airport transfer or a late-night city drop, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable and relaxing travel experience from Pune to Mumbai."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans for Pune to Mumbai routes."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We provide a variety of vehicle options including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and corporate groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Pune",
    WhyChoosedescription: "Velocity Cabs provides convenient doorstep pickup from homes, hotels, offices, and railway stations across Pune including areas like Kharadi, Hinjewadi, Wakad, Baner, Hadapsar, and Viman Nagar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by travelers for Pune to Mumbai cab bookings due to our punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Pune to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Pune to Mumbai with comfortable vehicles and professional drivers." },
  { question: "Is Pune to Mumbai cab service available 24 hours?", answer: "Yes, our Pune to Mumbai cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Pune to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers for group travel." },
  { question: "Can I book a one-way cab from Pune to Mumbai?", answer: "Yes, we provide one-way cab services as well as round-trip bookings between Pune and Mumbai." },
  { question: "Do you provide pickup from Pune Airport or railway station?", answer: "Yes, our drivers provide pickup from Pune Airport, Pune Railway Station, hotels, homes, and offices across the city." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book Pune to Mumbai cab service online?", answer: "Yes, customers can easily book Pune to Mumbai cabs online or through phone booking with Velocity Cabs." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and peak travel seasons." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides direct drop services to Mumbai Airport and other locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback:
      "A smooth and comfortable Pune to Mumbai cab journey. The vehicle was clean, the ride was punctual, and the overall travel experience felt relaxed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Deshmukh",
    feedback:
      "The Pune to Mumbai cab service was very reliable and well-managed. The driver was professional, the ride was steady, and everything felt safe and hassle-free.",
    rating: 5
  }
];












































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers the best Pune to Mumbai cab service with reliable, affordable, and professional taxi solutions. Book one-way and round-trip cabs including Ertiga, Innova, and Innova Crysta for airport transfers, outstation trips, and corporate travel. Enjoy safe, comfortable, and punctual rides from Pune to Mumbai at the best prices.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Pune to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai cab with Velocity Cabs. Affordable taxi service for one-way, round trip, airport transfer, Innova, Ertiga & Crysta cabs. Safe, reliable & cheapest Pune to Mumbai taxi service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaicab;